<navigation></navigation>
<router-outlet> </router-outlet>
<app-contact></app-contact>
